import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

import StatusEdit       from '@project/parts/side-influencer/status-edit';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class InfluencerStatus extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      is_edit : false,
    };
  }
  // -------------------------------------------------------
  
  toggleEdit(flg) {
    this.setState({ is_edit: flg });
    
    if( flg == false ) this.props.base.event.refreshInfluencer.bind(this)(this.props.detail.insta_user_id);
  }
  // -------------------------------------------------------
  
  render() {
    let base   = this.props.base;
    let detail = this.props.detail;
    
    let basic_status = [
      { id: 'is_manage_system',     name: 'システム連携' },
      { id: 'is_contract',          name: '基本契約'     },
      { id: 'is_entry',             name: 'エントリー'   },
      { id: 'is_private_info',      name: '個人情報'     },
    ];
    
    let progress_status = CastingCommon.getProgressStatus(detail.workflow.progress, detail.workflow_groups.list, detail.workflow.is_ng);
    
    let contract_money = detail.workflow_status.contract_money;
    if( contract_money == undefined ) contract_money = null;
    
    let posting_date = detail.workflow_status.posting_date;
    if( posting_date == undefined ) posting_date = null;
    
    let ng_reason = null;
    base.ng_reason.map((d) => { if( d.id == detail.workflow_status.ng_reason ) ng_reason = d.reason; });
    
    return (
      <div className="influencer-contents-status">
        
        <div className="basic-status">
          { basic_status.map((d, key) => {
            let status = (detail.accounts_status[d.id] == 1);
            return (
              <div key={key} className="basic-status-item">
                <h6>{d.name}</h6>
                { (status == true) ? <h2 className="done"><i className="material-icons">check_circle</i></h2> : <h2>-</h2> }
              </div>
            );
          })}
        </div>
        
        { (this.state.is_edit == true)
          ? <div className="edit-button on" onClick={this.toggleEdit.bind(this, false)}><i className="material-icons">close</i>閉じる</div>
          : <div className="edit-button off" onClick={this.toggleEdit.bind(this, true)}><i className="material-icons">edit</i>編集</div>
        }
        
        { (this.state.is_edit == true)
          ? <StatusEdit
              detail     = {detail}
              base       = {this.props.base}
              refresh_ev = {this.props.refresh_ev.bind(this)}
            />
          : <div className="status-preview">
              <div className="status-item">
                <h6>ステータス</h6>
                <div className={'base-status-box color_'+ progress_status.color}>
                  <div className="base-status">
                    <img src={'/images/workflow/'+ progress_status.image +'_m.png'} />
                    <p>{progress_status.rename}</p>
                  </div>
                </div>
                
                { (progress_status.id == 'ng') &&
                  <p className="ng-reason">{(ng_reason != null) ? <span className="ng-msg">NG理由: {ng_reason}</span> : <span className="none">NG理由が未選択</span> }</p>
                }
              </div>
              
              <div className="status-item status-item-post-contents">
                <h6>投稿種別</h6>
                
                { (detail.workflow_post_contents.length == 0)
                  ? <div className="none">投稿種別を設定していません</div>
                  : <ul>
                      { detail.workflow_post_contents.map((d, key) => {
                        return (
                          <li key={key}>
                            {d.name}
                          </li>
                        );
                      })}
                    </ul>
                }
              </div>
              
              <div className="status-item contract-money">
                <h6>報酬</h6>
                
                { (contract_money != null)
                  ? <p>\{Utils.viewInt(contract_money)}<span>(税別)</span></p>
                  : <p className="none">未設定</p>
                }
              </div>
              
              <div className="status-item contract-money">
                <h6>投稿予定日</h6>
                
                { (posting_date != null)
                  ? <p>{Utils.setDate(posting_date, 'YYYY/M/D HH:mm')}</p>
                  : <p className="none">未設定</p>
                }
              </div>
              
              <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>インフルエンサーのツール画面のプレビューを表示します</Tooltip>}>
                <a href={'https://casting.moribus.jp/demo/'+ base.project.unique_code +'/'+ detail.insta_user_id} target="_blank"><i className="material-icons">link</i>プレビュー</a>
              </OverlayTrigger>
            </div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerStatus;